'use client';

import Image_1 from '@/assets/images/faq/Myorders.svg';
import Image_2 from '@/assets/images/faq/Payment.svg';
import Image_3 from '@/assets/images/faq/Products.svg';
import Image_4 from '@/assets/images/faq/Promotion.svg';
import Image_5 from '@/assets/images/faq/Returns&Refund.svg';
import Image_6 from '@/assets/images/faq/Shipping&Delivery.svg';

import search from '@/assets/images/faq/search.svg';
import Button from '@/components/Button';
import { isMatchMobileMedia } from '@/util/is-match-mobile-media';
import { Tabs } from 'antd';
import Image from 'next/image';
import { useCallback, useEffect, useRef, useState } from 'react';
import classes from './faqPage.module.css';

import dynamic from 'next/dynamic';
import NoSsr from '../no-ssr';

const FaqAutoComplete = dynamic(() => import('./faq-auto-complete'), {
  ssr: false,
  loading: () => <div className='h-[50px] w-[calc(100%_-_100px)] lg_h-[60px] lg_w-[500px]'></div>,
});

const TYPE_1 = 'PROMOTION';
const TYPE_2 = 'PAYMENT';
const TYPE_3 = 'MY ORDERS';
const TYPE_4 = 'SHIPPING & DELIVERY';
const TYPE_5 = 'RETURNS & REFUND';
const TYPE_6 = 'WARRANTY';

const TitleIndexMap = new Map([
  [TYPE_1, 0],
  [TYPE_2, 1],
  [TYPE_3, 2],
  [TYPE_4, 3],
  [TYPE_5, 4],
  [TYPE_6, 5],
]);

const FaqPage = ({ faqItems: options }) => {
  const [optiondata, setOptiondata] = useState(options);

  useEffect(() => {
    setOptiondata([...options]);
  }, [options]);

  const [qaStatus, setQAStatus] = useState([
    ...options.map(item => {
      return {
        q: item.value,
        s: false,
      };
    }),
  ]);

  useEffect(() => {
    setQAStatus([
      ...options.map(item => {
        return {
          q: item.value,
          s: false,
        };
      }),
    ]);
  }, [options]);

  const [keyWord, setKeyWord] = useState('');

  const [tabsctiveKey, setTabsActiveKey] = useState('0');
  const markKeyWordFnRef = useRef(null);
  const [qtypeArray, setQtypeArray] = useState([]);
  // 此处根据后台修改

  const setOpen = useCallback(
    q => {
      q = clearmarkhtml(q);

      const currentobj = qaStatus.filter(item => item.q == q)[0];

      const otherobj = qaStatus.filter(item => item.q != q);

      if (!currentobj) {
        return;
      }

      if (currentobj.s) {
        currentobj.s = false;
      } else {
        currentobj.s = true;
        otherobj.map(item => {
          item.s = false;
        });
      }

      setQAStatus([...qaStatus]);
    },
    [qaStatus],
  );

  const onSelect = function (v, o) {
    setOpen(v);

    if (!isMatchMobileMedia()) {
      if (o.qtype == TYPE_4 || o.qtype == TYPE_5 || o.qtype == TYPE_6) {
        window.scrollTo(0, 1300);
      } else {
        window.scrollTo(0, 450);
      }
    } else {
      setTabsActiveKey(TitleIndexMap.get(o.qtype).toString());
      window.scrollTo(0, 250);
    }
  };

  const onChange = function (v) {
    setKeyWord(v);
  };

  const clearmarkhtml = function (keyWord) {
    return keyWord
      ?.replace(new RegExp('<span style="background-color:#2F6132;color:#fff">', 'g'), '')
      .replace(new RegExp('</span>', 'g'), '');
  };

  const onChangeTab = function (key) {
    setTabsActiveKey(key);
  };

  const markKeyWord = () => {
    optiondata.map(item => {
      item.value = clearmarkhtml(item.value);
      const ofindex = item.value.toLocaleLowerCase().indexOf(keyWord.toLocaleLowerCase());

      if (item.value.toLocaleLowerCase() == keyWord.toLocaleLowerCase()) {
        item.value = '<span style="background-color:#2F6132;color:#fff">' + item.value + '</span>';
      } else {
        if (ofindex > -1) {
          if (isMatchMobileMedia()) {
            if (!qtypeArray.includes(item.qtype)) {
              qtypeArray.push(item.qtype);
              setQtypeArray([...qtypeArray]);
            }

            if (qtypeArray.length) {
              setTabsActiveKey(TitleIndexMap.get(qtypeArray[0]).toString());
            }
          }

          item.value = item.value.replace(
            new RegExp(item.value.substring(ofindex, ofindex + keyWord.length), 'g'),
            '<span style="background-color:#2F6132;color:#fff">' +
              item.value.substring(ofindex, ofindex + keyWord.length) +
              '</span>',
          );
        } else {
          item.value = item.value.replace(
            new RegExp(keyWord, 'g'),
            '<span style="background-color:#2F6132;color:#fff">' + keyWord + '</span>',
          );
        }
      }
    });
    setOptiondata([...optiondata]);
    setQtypeArray([]);
  };
  markKeyWordFnRef.current = markKeyWord;

  function QAitem(v) {
    v = v.v;

    const matched = qaStatus.filter(qitem => qitem.q == clearmarkhtml(v.value));
    const isOpen = matched.length > 0 && matched[0]?.s;

    return (
      <li className={classes.qaitem}>
        <p
          className={[classes.q, isOpen ? classes.qctive : null].join(' ')}
          onClick={() => setOpen(v.value)}
          dangerouslySetInnerHTML={toHTML(v.value)}
        />
        {/* 答案始终渲染进 DOM（仅用 CSS 控制展开/收起），
            确保搜索引擎能抓到问答正文，而不是只有问题 */}
        <div
          className={classes.a}
          style={{ display: isOpen ? undefined : 'none' }}
          dangerouslySetInnerHTML={toHTML(v.answer)}
        />
      </li>
    );
  }

  const questiontype = [
    {
      title: TYPE_1,
      img: Image_1,
    },
    {
      title: TYPE_2,
      img: Image_2,
    },
    {
      title: TYPE_3,
      img: Image_3,
    },
    {
      title: TYPE_4,
      img: Image_4,
    },
    {
      title: TYPE_5,
      img: Image_5,
    },
    {
      title: TYPE_6,
      img: Image_6,
    },
  ];
  const toHTML = str => ({
    __html: str,
  });

  const itemlist = questiontype.map((item, index) => (
    <div
      key={index}
      className={classes.item}
    >
      <div className={classes.itemtitle}>
        <Image
          className={classes.itemtitleicon}
          src={item.img}
          alt=''
        />
        <h2>{item.title}</h2>
      </div>
      <ul className={classes.itemcon}>
        {optiondata
          .filter(qaitem => qaitem.qtype == item.title)
          .map((v, i) => (
            <QAitem
              v={v}
              key={i}
            />
          ))}
      </ul>
    </div>
  ));

  const itemlist_m = (
    <div className={classes.item}>
      <Tabs
        activeKey={tabsctiveKey}
        tabPosition='top'
        onChange={onChangeTab}
        items={questiontype.map((_, i) => {
          const id = String(i);

          return {
            label: _.title,
            key: id,
            children: (
              <ul className={classes.itemcon}>
                {optiondata
                  .filter(qaitem => qaitem.qtype == _.title)
                  .map((v, i) => (
                    <QAitem
                      v={v}
                      key={i}
                    />
                  ))}
              </ul>
            ),
          };
        })}
      />
    </div>
  );

  useEffect(() => {
    document.onkeydown = function (e) {
      // 兼容FF和IE和Opera
      const theEvent = window.event || e;
      const code = theEvent.keyCode || theEvent.which || theEvent.charCode;

      if (code == 13) {
        markKeyWordFnRef.current();
      }
    };
  }, []);

  if (!Array.isArray(options) || options.length === 0) {
    return null;
  }

  return (
    <div className=''>
      <Image
        src='/images/faq/banner-m.webp'
        width={375}
        height={200}
        className='block h-auto w-full lg_hidden'
        alt=''
        unoptimized
        priority
      />
      <Image
        src='/images/faq/banner.webp'
        width={1920}
        height={370}
        className='hidden h-auto w-full lg_block'
        alt=''
        unoptimized
        priority
      />

      <div className='block bg-[#EFEFEF] p-[20px] lg_hidden'>
        <p className='font-poppins text-[30px] font-[700] uppercase text-title'>FIND ANSWERS FAST </p>
        <p className='mt-[10px] font-sans text-title'>
          From orders to bird feeding tips, we’ve got you covered. Explore our most common questions and get the help
          you need.
        </p>
      </div>

      <div className={[classes.root, classes.faq].join(' ')}>
        <h1 className='my-[20px] text-center font-poppins text-[30px] font-[600] uppercase text-primary lg_mb-[40px] lg_mt-[80px] lg_text-primary'>
          We are here to help you!
        </h1>
        <div className={classes.searchcon}>
          <FaqAutoComplete
            options={options}
            onSelect={onSelect}
            onChange={onChange}
            allowClear
            placeholder='Try to type "shipping"'
            filterOption={(inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
          />
          <Button
            className='flex  h-[50px] w-[50px] items-center justify-center bg-primary hover_bg-primary lg_h-[60px] lg_w-[60px]'
            id='searchBtn'
            onClick={markKeyWord}
          >
            <Image
              width='30'
              height='30'
              src={search}
              alt=''
            />
          </Button>
        </div>
        <div className='px-mbpx mt-10 grid grid-cols-1 gap-y-10 sm_mt-20 sm_grid-cols-3 sm_gap-20 sm_px-0 lg_hidden'>
          <NoSsr>{itemlist_m}</NoSsr>
        </div>
        <div className='px-mbpx mt-10 hidden grid-cols-1 gap-y-10 sm_mt-20 sm_grid-cols-3 sm_gap-20 sm_px-0 lg_grid'>
          {itemlist}
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
